import Info2Content from '../components/info/Info2PageContent';

const Info2Page = () => {
  return <Info2Content />;
};

export default Info2Page;